import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Space, Tag, Tooltip } from 'antd';
import { ScoreInputNumber } from '../score-input';
import { SubmissionScore } from '@module/assignment';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledSpace = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  border: ", ";\n"])), function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 0;
  }

  return styleVariables.padding.large;
}, styleVariables.borderRadius.medium, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'transparent';
  }

  return props.theme.color.bgDefault;
}, function (props) {
  return "".concat(styleVariables.borderWidth.small, " solid ").concat(props.theme.color.borderDefault);
});
var StyledDescription = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), styleVariables.font.fontWeightStrong, styleVariables.font.fontSizeSmall);
var ExplanationArea = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: ", ";\n  padding: ", ";\n\n  background-color: ", ";\n"])), styleVariables.borderRadius.medium, styleVariables.padding.medium, function (props) {
  return props.theme.color.backgroundOverlay;
});
var ExplanationTitle = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong);
var ExplanationContent = styled(MathEnabledTextComponent)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n\n  p {\n    margin: 0;\n  }\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightNormal);
var StyledLabel = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong);
var StyledHeaderArea = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
export var GradingAnswer = function GradingAnswer(_ref) {
  var children = _ref.children,
      question = _ref.question,
      label = _ref.label,
      disabled = _ref.disabled,
      score = _ref.score,
      onGradeAnswer = _ref.onGradeAnswer;

  var renderExplanation = function renderExplanation() {
    if (question.explanation === undefined) {
      return;
    }

    var isEmptyExplanation = question.explanation === '';
    var defaultExplanationContent = isEmptyExplanation ? /*#__PURE__*/_jsxs("i", {
      children: ["(", label.notHaveExplanationForThisQuestion, ")"]
    }) : /*#__PURE__*/_jsx(ExplanationContent, {
      value: question.explanation
    });
    return /*#__PURE__*/_jsxs(ExplanationArea, {
      children: [/*#__PURE__*/_jsx(ExplanationTitle, {
        children: label.explanation
      }), defaultExplanationContent]
    });
  };

  return /*#__PURE__*/_jsxs(StyledSpace, {
    direction: "vertical",
    size: "small",
    id: "ga_".concat(question.id),
    children: [/*#__PURE__*/_jsxs(StyledHeaderArea, {
      children: [/*#__PURE__*/_jsx(Space, {
        children: /*#__PURE__*/_jsx(StyledLabel, {
          children: "".concat(label.question, " ").concat(question.titleIndex)
        })
      }), /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: disabled ? label.disabledScoreInputText : '',
          children: /*#__PURE__*/_jsx(ScoreInputNumber, {
            label: {
              score: label.score
            },
            disabled: disabled,
            min: 0,
            max: question.score,
            score: score === SubmissionScore["default"].value ? null : score,
            onGradedScore: onGradeAnswer
          })
        }), !disabled && score === SubmissionScore["default"].value && /*#__PURE__*/_jsx(Tag, {
          children: label.notGraded
        })]
      })]
    }), /*#__PURE__*/_jsx(StyledDescription, {
      value: question.description
    }), /*#__PURE__*/_jsx("div", {
      children: children
    }), renderExplanation()]
  });
};